import { createSlice } from '@reduxjs/toolkit';

const couponSlice = createSlice({
  name: 'couponSlice',
  initialState: {
    isLoading: false,
    isViewLoading: false,
    couponListData: [],
    isError: null,
    viewCouponDetails: null,
    filters: {
      search: '',
      status: '',
      couponType: '',
      dateRange: {
        startDate: null,
        endDate: null,
      },
    },
  },
  reducers: {
    /////// Coupon list start //////
    requestCouponList: (state) => {
      return { ...state, isLoading: true };
    },
    responseCouponList: (state, action) => {
      return {
        ...state,
        isLoading: false,
        couponListData: action?.payload?.data,
      };
    },
    failureCouponList: (state, action) => {
      return {
        ...state,
        isLoading: false,
        isError: action?.payload,
      };
    },

    /////// Coupon Add-Edit //////
    requestCouponAdd: (state) => {
      return { ...state, isLoading: true };
    },
    responseCouponAdd: (state) => {
      return { ...state, isLoading: false };
    },
    failureCouponAdd: (state, action) => {
      return { ...state, isLoading: false, isError: action?.payload };
    },

    ////////// Coupon View /////////
    requestCouponView: (state) => {
      return { ...state, isViewLoading: true };
    },
    responseCouponView: (state, action) => {
      return {
        ...state,
        isViewLoading: false,
        viewCouponDetails: action.payload,
      };
    },
    failureCouponView: (state, action) => {
      return { ...state, isViewLoading: false, isError: action?.payload };
    },

    ////// Coupon Delete ////
    requestCouponDelete: (state) => {
      return { ...state, isLoading: true };
    },
    responseCouponDelete: (state) => {
      return { ...state, isLoading: false };
    },
    failureCouponDelete: (state, action) => {
      return { ...state, isLoading: false, isError: action?.payload };
    },

    ////// Coupon Filters ////
    setCouponFilters: (state, action) => {
      return { ...state, filters: { ...state.filters, ...action.payload } };
    },
    clearCouponFilters: (state) => {
      return {
        ...state,
        filters: {
          search: '',
          status: '',
          couponType: '',
          dateRange: {
            startDate: null,
            endDate: null,
          },
        },
      };
    },
  },
});

export const {
  failureCouponList,
  requestCouponList,
  responseCouponList,
  failureCouponAdd,
  requestCouponAdd,
  responseCouponAdd,
  failureCouponView,
  requestCouponView,
  responseCouponView,
  failureCouponDelete,
  requestCouponDelete,
  responseCouponDelete,
  setCouponFilters,
  clearCouponFilters,
} = couponSlice.actions;

export default couponSlice.reducer;
